import { create } from 'zustand';

interface LoadingState {
  loading: boolean;
  setLoading: (input: boolean) => void;
}

export const useLoadingStore = create<LoadingState>((set) => ({
  loading: false,
  setLoading: (input) => set((state) => ({ ...state, loading: input })),
}));
